import Icon from '../components/Icon.vue'

Icon.register({
  cubes: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488.6 250.2c14.1 5.3 23.4 18.7 23.4 33.7v110.1c0 13.6-7.7 26.1-19.9 32.2l-100 50c-10.1 5.1-22.1 5.1-32.2 0l-103.9-52-103.9 52c-10.1 5.1-22.1 5.1-32.2 0l-100-50c-12.2-6.1-19.9-18.6-19.9-32.2v-110.1c0-15 9.3-28.4 23.3-33.7l96.6-36.2v-108.5c0-15 9.3-28.4 23.4-33.7l100-37.5c8.2-3.1 17.2-3.1 25.3 0l100 37.5c14.1 5.3 23.4 18.7 23.4 33.7v108.5zM358 214.8v-73.3l-85 37v68.2zM154 104.1v0.6l102 41.4 102-41.4v-0.6l-102-38.2zM238 395.2v-75.4l-85 38.8v79.1zM238 283.2v-0.6l-102-38.2-102 38.2v0.6l102 41.4zM478 395.2v-75.4l-85 38.8v79.1zM478 283.2v-0.6l-102-38.2-102 38.2v0.6l102 41.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cubes.js
// module id = 1250
// module chunks = 0